module.exports = __webpack_public_path__ + "img/3-right-red.d14a94e0.png";